import React, { Component } from "react";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import { CourseResource } from "../../../../../stores/CoursesStore/Types";
import { CourseCategoryResource } from "../../../../../stores/CourseCategoriesStore/Types";
import CourseBody from "./CourseBody";

interface Props {
  courseResource: CourseResource;
  idx: number;
  useATag?: boolean;
  categories?: CourseCategoryResource[];
  increaseHeight?: boolean;
  userIsInUk: boolean;
}

class Course extends Component<Props, {}> {
  courseLink = () => {
    const { courseResource } = this.props;
    if (courseResource.embedded_host_url) {
      return courseResource.embedded_host_url;
    } else if (courseResource.enrolment_id) {
      return `/enrolments/${courseResource.enrolment_id}`;
    }

    return courseResource.course_path;
  };

  render() {
    const { courseResource, idx, useATag, categories, userIsInUk } = this.props;

    return (
      <div
        className="column animateme three"
        data-from={0.45 + 0.07 * idx}
        data-opacity="0"
        data-to={idx * 0.07}
        data-translatey="180"
        data-when="enter"
      >
        <div className="ui loader"></div>

        {useATag || courseResource.content_version == "upcoming" ? (
          <a className="content" href={this.courseLink()}>
            <CourseBody
              courseResource={courseResource}
              userIsInUk={userIsInUk}
            />
          </a>
        ) : (
          <Link className="content" to={this.courseLink()}>
            <CourseBody
              courseResource={courseResource}
              userIsInUk={userIsInUk}
            />
          </Link>
        )}
      </div>
    );
  }
}

export default observer(Course);
